import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/warehouse/allot/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/warehouse/allot/detail', Object.assign({}, options, { params }));

export const getUserlist = (params, options) =>
request.get('/api/v4ward/warehouse/keeper/getKeeperList', Object.assign({}, options, { params }));

export const getDegetConsumableListByRequisitionIdtail = (params, options) =>
request.get('/api/v4ward/warehouse/consumable/listWithStock', Object.assign({}, options, { params }));

export const consumableList = (params, options) =>
request.get('/api/v4ward/warehouse/consumable/listWithStock', Object.assign({}, options, { params }));

// 申请
export const applyFormDetail = (params, options) =>
request.post('/api/v4ward/warehouse/allot/submit', params,options);

// 申请
export const saveFormDetail = (params, options) =>
request.post('/api/v4ward/warehouse/allot/save', params,options);


// 审核 3：通过 4驳回
export const aduit = (params, options) =>
request.post('/api/v4ward/warehouse/allot/audit', params,options);

// 调拨出库提交
export const allotOutboundSubmit = (params, options) =>
request.post('/api/v4ward/warehouse/allot/allotOutbound', params,options);

// 关单 3：通过 4驳回
export const closeOrderAction = (params, options) =>
request.post('/api/v4ward/warehouse/allot/close', params,options);

// 关单 3：通过 4驳回
export const allotInboundAction = (params, options) =>
request.post('/api/v4ward/warehouse/allot/allotInbound', params,options);
// 出库金额计算
export const consumableCalculate = (params, options) =>
    request.get('/api/v4ward/warehouse/outbound/consumable/calculate', Object.assign({}, options, { params }))

